import { MOTION_PICK_MIN } from "@fiket/booth-schema";
import type { Route } from "../../store/router";
import { videoGenerateEntryRoute } from "../Payment/paymentFlow";

/**
 * 영상 애드온 분기 규칙 — 순수 함수 (vitest). review → videoIntro → videoMotions? → videoCaption? → (payment)? → videoGenerate.
 * - 영상 소개(9.1)는 **항상** 거친다 — 샘플 영상이 있으면 루프, 없으면 손님의 변환 사진을 프레임에 보여준다(2026-10-13 결정).
 * - 동작 선택(9.2)은 고를 동작이 MOTION_PICK_MIN 개(1) 이상일 때만 — 하나만 있어도 고르게 한다.
 * - 자막 입력(9.3, BOOTH-85)은 부스 `captionEnabled`(`resolveCaptionEnabled`, 없음 = 켬) 가 켬일 때 거친다 — "넣지 않기" 로 건너뛸 수 있다.
 *   끔이면(키오스크 키보드 입력이 불편한 행사) 화면 자체를 건너뛰고 앞 화면이 결제 분기를 대신 맡는다. 결제 뒤엔 되돌아가지 않으므로 자막은 결제 전에 고정.
 * - 결제 유효 ON 이면 생성 직전에 결제 화면이 끼어든다 (BOOTH-61/74). `beginPayment(true)` 호출은 생성 직전 화면(자막 켬 = 자막 화면, 끔 = 동작 선택 또는 소개) 이 맡는다.
 */

/**
 * 소개(9.1) 다음 — 고를 동작이 MOTION_PICK_MIN 개 이상 있으면 동작 선택(9.2).
 * 없으면 자막 켬 = 자막 입력(9.3), 자막 끔 = 바로 결제(걸리면) 또는 생성.
 */
export function afterIntroRoute(motionCount: number, captionEnabled: boolean, anyPaymentActive: boolean): Route {
  if (motionCount >= MOTION_PICK_MIN) return "videoMotions";
  return captionEnabled ? "videoCaption" : videoGenerateEntryRoute(anyPaymentActive);
}

/** 동작 선택(9.2) 다음 — 자막 켬 = 자막 입력, 끔 = 바로 결제(걸리면) 또는 생성. */
export function afterMotionsRoute(captionEnabled: boolean, anyPaymentActive: boolean): Route {
  return captionEnabled ? "videoCaption" : videoGenerateEntryRoute(anyPaymentActive);
}

/**
 * 자막 입력(9.3) 다음 — 사진·영상 어느 쪽이든 결제가 걸리면(anyPaymentActive) 생성 대신 결제가 먼저다 (영상 생성 직전, BOOTH-61/74/80).
 * "다음"(자막 있음)·"넣지 않기" 둘 다 같은 분기.
 */
export function afterCaptionRoute(anyPaymentActive: boolean): Route {
  return videoGenerateEntryRoute(anyPaymentActive);
}

/** 결과 화면 "영상으로도 만들기" 가 가는 곳. */
export function videoEntryRoute(): Route {
  return "videoIntro";
}

/** 동작 선택 화면의 뒤로 — 항상 소개 화면. */
export function videoBackRoute(): Route {
  return "videoIntro";
}

/** 자막 화면의 뒤로 — 동작을 골랐으면(= 동작 선택을 거쳤으면) 동작 선택, 아니면 소개. */
export function captionBackRoute(hasMotions: boolean): Route {
  return hasMotions ? "videoMotions" : "videoIntro";
}

/**
 * 생성 화면의 뒤로 — 바로 앞 화면. 자막 켬이면 자막 입력, 끔이면 자막 화면이 없었으니 동작 선택(골랐으면) 또는 소개.
 * 결제 뒤엔 뒤로가기 자체가 없다.
 */
export function generateBackRoute(captionEnabled: boolean, hasMotions: boolean): Route {
  return captionEnabled ? "videoCaption" : captionBackRoute(hasMotions);
}
